<script setup>
import SInfoMontant from '@/components/global/s-info-montant.vue'
</script>

<template>
  <v-chip outlined :color="color">
    <v-icon class="mr-1" small :color="color">
      {{ icone }}
    </v-icon>
    <s-info-montant colorisation :montant="opAjustement.montant" />
  </v-chip>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    opAjustement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getIconePourPosteAIMId: 'posteAIM/getIconePourPosteAimId',
    }),
    icone() {
      return this.getIconePourPosteAIMId(this.opAjustement.posteAIM.posteAIMId)
    },
    color() {
      return this.opAjustement.montant > 0 ? 'success' : 'error'
    },
  },
}
</script>

<style scoped></style>
